import { SET_LANG } from "../actions/settings";

const savedLang = localStorage.getItem("lang");

const initialState = {
  lang: !savedLang ? "de" : savedLang,
};

const settings = (state = initialState, action) => {
  switch (action.type) {
    case SET_LANG:
      localStorage.setItem("lang", action.payload);
      return {
        ...state,
        lang: action.payload,
      };
    default:
      return state;
  }
};

export default settings;
